import { CompanySettings } from "@mcleod/core";
import { AutogenLayoutReceivablesHistoryExpand } from "./autogen/AutogenLayoutReceivablesHistoryExpand";

export class ReceivablesHistoryExpand extends AutogenLayoutReceivablesHistoryExpand {
    override onLoad() {
        const companySettings = CompanySettings.getSingleton();
        this.checkboxIsIntercompany.visible = companySettings.isIntercompanyMainCompany();
        this.textboxCompanyId.visible = companySettings.isIntercompanyMainCompany();
    }
}
